module.exports = __webpack_public_path__ + "static/media/testimoni2.1de6a262.png";